<template>
  <div>
    <div class="g_box">
      <div>
        <img :src="serve + '/bannerAD/second_page1.png'" alt>
      </div>
      <div style="height:51px;background-color: rgb(245, 245, 245);"></div>
      <div class="g_box1">
        <div class="g_box_content">
          <!-- <div class="content_top">
            <p>上海技高家电维修部 : 5G阿芳来临之际基本定型</p>
          </div> -->
          <div class="content_cont" v-html="cont">
          </div>
          <!-- <div class="content_btm">
            <img width="650px" height="350px" src="../../assets/images/jingtai.png" alt>
          </div> -->
        </div>
        <div class="g_box_right">
          <div class="g_new">最新推荐</div>
          <div class="g_new_content" v-for="items in imgData" :key="items.index" >
            <img :src=" serve + items.images" alt>
            <router-link :to="'/product/' + items.id" tag="p">{{items.title}}</router-link>
            <p>&yen; {{items.selling_price}}</p>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: rgb(245, 245, 245);height:60px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      id: this.$route.params.id,
      cont:'',
      imgData:[],
    };
  },
  created() {
     this.content()
     this.commodity()
  },
  methods: {
    content() {
      this.axios
        .get(this.serve + "/second_page", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          this.cont = res.data
        });
    },
    commodity(){
       this.axios.get(this.serve + '/new_recommend').then(res=>{
          this.imgData =  res.data
       })
    }
  }
};
</script>

<style lang="scss">
.g_box {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  .g_box1 {
    display: flex;
  }
  .g_box_content {
    width: 900px;
    .content_top {
      padding: 80px 171px 0 171px;
      font-size: 24px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .content_cont {
      padding:  50px 171px 0 30px;
      line-height: 30px;
      font-size: 14px;
      color: #666666;
    }
    .content_btm {
      margin-top: 29px;
      padding-bottom: 149px;
      img {
        margin: 0 auto;
      }
    }
  }
  .g_box_right {
    width: 300px;
    border: 1px solid rgba(221, 221, 221, 1);
    .g_new {
      width: 100%;
      height: 48px;
      background: rgba(246, 78, 98, 1);
      line-height: 48px;
      text-align: center;
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(254, 254, 254, 1);
      margin-bottom: 30px;
    }
    .g_new_content {
      padding-bottom: 30px;
      width: 240px;
      margin: 0 auto;
      text-align: center;
      img {
        width: 240px;
        height: 240px;
      }
      :nth-child(2) {
        cursor: pointer;
        font-size: 14px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      :nth-child(2):hover{
          color: rgba(246, 78, 98, 1);
      }
      :nth-child(3) {
        font-size: 14px;
        font-family: "MicrosoftYaHei";
        font-weight: bold;
        color: rgba(246, 78, 98, 1);
      }
    }
  }
}
</style>
